<template>
  <div class="lg:flex mb-20 lg:mb-40">
    <ItemWork v-for="(item, index) in items" :key="index" :item="item" />
  </div>
</template>
<script>
import staticData from './static-data'
import ItemWork from './item-work.vue'

export default {
  name: 'ItemWorks',
  components: {
    ItemWork
  },
  data () {
    return {
      items: staticData.component.HowItWorks
    }
  }
}
</script>
